import React from "react";

import bannerLogo from "../../assets/images/Banner.png";

class CommonContentTop extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12 bannerDiv">
            <img src={bannerLogo} className="img-fluid bannerLogo"></img>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p className="text-center orderFnBText">Order Food and Drinks Online</p>
          </div>
        </div>
        {window.location.pathname.includes("menu") ? (
          <section className="yourSelection">
            <h2>Your Selection</h2>
            <section className="usInner">
              <ul className="usList">
                <li className="selectedLocation">
                  <p>
                    {/* Wisconsin, <span className="d-block">Majestic Cinema of Brookfield</span> */}
                    {this.props.appState.compHomeSelectedOptions.stateFullString}, <span>{this.props.appState.compHomeSelectedOptions.cinemaFullString}</span>
                  </p>
                </li>
                <li className="selectedDeliveryOption">
                  <p>
                    {/* Delivery to my seat */}
                    {this.props.appState.compHomeSelectedOptions.deliverOption}
                  </p>
                </li>
                <li className="selectedShowtimeInfo">
                  <aside className="showtimeDetails">
                    {this.props.appState.compHomeSelectedOptions.deliverOption == "Delivery to your seat" ? (
                      <>
                        <p>
                          <span>{this.props.appState.compHomeSelectedOptions.showDateFullString}</span> <span>{this.props.appState.compHomeSelectedOptions.movieFullString}</span>
                        </p>
                        <p>
                          <span>{this.props.appState.compHomeSelectedOptions.showTime}</span> <span>{this.props.appState.compHomeSelectedOptions.seatNumber}</span>
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          <span>{this.props.appState.compHomeSelectedOptions.pickUpDate}</span> <span>{this.props.appState.compHomeSelectedOptions.pickUpTime}</span>
                        </p>
                      </>
                    )}
                    {/* <p> <span>Sun, Oct 23</span> <span>Lyle, Lyle, Crocodile</span> </p>
                    <p> <span>04:00 PM</span> <span>D10</span> </p> */}
                  </aside>
                </li>
                <li className="selectedDeliveryTime">
                  <p>
                    {this.props.appState.compHomeSelectedOptions.deliverOption == "Delivery to your seat"
                      ? this.props.appState.compHomeSelectedOptions.deliverToSeatTime
                      : this.props.appState.compHomeSelectedOptions.pickUpTime}
                    {/* 4:30 PM */}
                  </p>
                </li>
              </ul>
              <aside className="btnswrap">
                <a
                  href="javascript:;"
                  className="btn btnEdit"
                  onClick={() => {
                    this.props.redirectToSelectionPage();
                  }}
                >
                  <span>Edit</span>
                </a>
              </aside>
            </section>
          </section>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default CommonContentTop;
